import type {HttpClient} from '@sollapay/http-client';
import type {
  ApiResponse,
  CreatePaymentInstructionPayload,
  CreatePaymentInstructionResponseDTO,
  PaymentInstructionDTO
} from '@sollapay/types';

export const paymentsApi = {
  fetchPayments: async (
    client: HttpClient,
    trustAccountId: string
  ): Promise<ApiResponse<PaymentInstructionDTO[]>> => {
    return client.get<ApiResponse<PaymentInstructionDTO[]>>(
      `/trust_accounts/${trustAccountId}/instructions/payments`
    );
  },

  createPaymentInstruction: async (
    client: HttpClient,
    trustAccountId: string,
    payload: CreatePaymentInstructionPayload
  ): Promise<ApiResponse<CreatePaymentInstructionResponseDTO>> => {
    return client.post<ApiResponse<CreatePaymentInstructionResponseDTO>>(
      `/trust_accounts/${trustAccountId}/instructions/payments`,
      payload
    );
  },

  resendPaymentInstruction: async (
    client: HttpClient,
    trustAccountId: string,
    paymentId: string,
    idempotencyKey: string
  ): Promise<ApiResponse<PaymentInstructionDTO>> => {
    return client.post<ApiResponse<PaymentInstructionDTO>>(
      `/trust_accounts/${trustAccountId}/instructions/payments/${paymentId}/resend`,
      {},
      {headers: {'Idempotency-Key': idempotencyKey}}
    );
  },

  cancelPaymentInstruction: async (
    client: HttpClient,
    trustAccountId: string,
    paymentId: string,
    idempotencyKey: string
  ): Promise<ApiResponse<PaymentInstructionDTO>> => {
    return client.post<ApiResponse<PaymentInstructionDTO>>(
      `/trust_accounts/${trustAccountId}/instructions/payments/${paymentId}/cancel`,
      {},
      {headers: {'Idempotency-Key': idempotencyKey}}
    );
  },

  setPaymentInstructionHandled: async (
    client: HttpClient,
    trustAccountId: string,
    paymentId: string,
    handled: boolean
  ): Promise<ApiResponse<PaymentInstructionDTO>> => {
    const path = `/trust_accounts/${trustAccountId}/instructions/payments/${paymentId}/handled`;
    return handled
      ? client.post<ApiResponse<PaymentInstructionDTO>>(path, {})
      : client.delete<ApiResponse<PaymentInstructionDTO>>(path);
  }
};
